import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  styled,
} from "@mui/material";

export type CertificateEnergyProps = {
  energyCertificate: string | null;
  energyConsumption: number | null;
  energyEmissionCertificate: string | null;
  energyEmission: number | null;
};

const certificates = ["A", "B", "C", "D", "E", "F", "G"];
const certificatesColor = [
  "#00a650",
  "#52b848",
  "#bdd630",
  "#fef200",
  "#fdb813",
  "#f47121",
  "#ee1c25",
];
export function CertificateEnergy({
  energyCertificate,
  energyConsumption,
  energyEmissionCertificate,
  energyEmission,
}: CertificateEnergyProps) {
  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell sx={{ textAlign: "center" }}>
              Consumo kwh/m2 año
            </TableCell>
            <TableCell sx={{ textAlign: "center" }}>
              Emisiones CO2/m2 año
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {certificates.map((x, i) => (
            <TableRow key={`certificate_${x}`}>
              <TableCell sx={{ width: "40%" }}>
                <CertificateEnergyBar
                  percent={70 + i * 5}
                  color={certificatesColor[i]}
                >
                  {x}
                </CertificateEnergyBar>
              </TableCell>
              <TableCell>
                {x === energyCertificate && (
                  <Typography fontWeight="bold" textAlign="center">
                    {energyConsumption
                      ? parseFloat(energyConsumption + "").toLocaleString(
                          "de-DE"
                        )
                      : "-"}
                  </Typography>
                )}
              </TableCell>
              <TableCell>
                {x === energyEmissionCertificate && (
                  <Typography fontWeight="bold" textAlign="center">
                    {energyEmission
                      ? parseFloat(energyEmission + "").toLocaleString("de-DE")
                      : "-"}
                  </Typography>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

const CertificateEnergyBar = styled(Box, {
  shouldForwardProp: (name) => !["color", "percent"].includes(name as string),
})<{ percent: number; color: string }>(({ color, percent }) => ({
  display: "flex",
  justifyContent: "end",
  width: percent + "%",
  backgroundColor: color,
  fontWeight: 700,
  fontSize: "1.2rem",
  position: "relative",
  paddingRight: 15,
  "&::after": {
    content: '""',
    position: "absolute",
    right: "-10px",
    top: 5,
    bottom: 0,
    width: 20,
    height: 18,
    backgroundColor: color,
    transform: "rotate(-45deg)",
    zIndex: 2,
  },
}));
